import React from "react";
import { AuthContainer, AuthWrapper, CompanyName, PortalSubtitle, FormCard, FormTitle, FormSubtitle } from "./index.styles";

const PortalNotFound = () => {
  return (
    <AuthWrapper>
      <AuthContainer>
        <CompanyName>Orderlink</CompanyName>
        <PortalSubtitle>B2B Customer Portal</PortalSubtitle>
        <FormCard style={{ marginTop: "24px" }}>
          <FormTitle>Portal Not Found</FormTitle>
          <FormSubtitle>
            We couldn't find a portal at this address. Please check the URL and try again.
          </FormSubtitle>
        </FormCard>
      </AuthContainer>
    </AuthWrapper>
  );
};

export default PortalNotFound;
